import React, { useContext } from 'react'
import { InputElement } from '../../../HtmlComponents/InputElement'
import { FormMoughataaContext } from '../types'

const InputsMoughataa = () => {
  const { name, setName } = useContext(FormMoughataaContext)

  return (<>
    <InputElement name="Nom" placeholder='Nom du moughataa' value={name} setValue={setName} />
  </>)
}

export default InputsMoughataa